<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/g6feb7/tc-custom/9780544317901.jpg?1700958420892" alt="This image is the cover for the book Book of Souls, The Detective Inspector McLean Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Book of Souls, The Detective Inspector McLean Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>When an Edinburgh serial killer is murdered in prison, his deadly legacy lives on to claim more victims in this “engrossing” Scottish detective mystery (<i>Publishers Weekly</i>).</b></p><p>For ten years, a gruesome Christmastime tradition terrorized Edinburgh. Each year as the holiday approached, a young woman’s body was found—naked, throat slit, body washed clean. The final victim, Kirsty Summers, was Detective Constable Tony McLean's fiancée. But the Christmas Killer made a mistake, and McLean finally put an end to the horror.</p><p>Now, twelve years later, a fellow prisoner has just murdered the incarcerated Christmas Killer. But with the arrival of the festive season comes a body. A young woman: naked, washed, her throat cut. Is this a copycat killer? Was the wrong man behind bars all this time? Or is there a more frightening explanation? McLean must revisit the most disturbing case of his life and discover what he missed before the killer strikes again.</p><b>“Oswald’s detective gives John Rebus a run for his money in this noirish page-turner.”—<i>Kirkus</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Oswald
      </h2>
      
      <p class="authorDescription body article">JAMES OSWALD is the author of the Detective Inspector McLean series of crime novels by night. During the day he runs a 350 acre livestock farm in North East Fife, Scotland where he raises Highland cattle and sheep.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (hmhbooks.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bf12daf